jQuery(document).ready(function($) {
    
	$('.site-popup__close').click(function() {
		$('#site-popup').hide();
		document.cookie = 'popup_check=true';
	});
 
});

